export default function Erro() {
    return (
        <div>
            Ops, essa página não existe
        </div>
    )
}